import script from "./CreatePolicyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatePolicyModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreatePolicyModal.vue?vue&type=style&index=0&id=8e1b3c20&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e1b3c20"]])

export default __exports__